export default function About() {
  return (
    <section id="about" className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-12">
          <p className="text-xs uppercase tracking-wider text-gray-500 mb-6">ABOUT J C CABRAL</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div className="space-y-8">
            <h2 className="text-6xl font-bold text-gray-900 leading-tight">
              Building Trust Through Technology
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              At J C CABRAL S.R.L., we are dedicated to creating innovative security solutions that protect your digital freedom. Based in Formosa, Argentina, our team of experts develops cutting-edge VPN technology that ensures your online activities remain private and secure.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              Our mission is to provide individuals and businesses with the tools they need to navigate the digital world safely. We believe that privacy is a fundamental right, and we are committed to making advanced security accessible to everyone.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-6">
            <div className="col-span-1">
              <div className="w-full h-80 rounded-2xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/02d7b6c60127d5ecd2203a595e54c6d1.jpg"
                  alt="Our Team"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="col-span-1 pt-12">
              <div className="w-full h-80 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=VPN%20security%20application%20interface%20on%20laptop%20screen%20showing%20encrypted%20connection%20and%20network%20protection%20features%2C%20modern%20software%20dashboard%20with%20dark%20theme%20and%20glowing%20elements%2C%20professional%20cybersecurity%20application%20with%20world%20map%20and%20server%20locations%2C%20clean%20UI%20design%20with%20teal%20and%20purple%20accent%20colors%20on%20minimalist%20background&width=500&height=600&seq=about-app-001&orientation=portrait"
                  alt="Our Application"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
